module.exports = __webpack_public_path__ + "img/reference17.7a84f3f7.jpg";